<template>
    <div class="paypal">
        <Menu :sesion="sesion" :url="url" v-if="sesion"/>
        <Submenu :menuActivo="2" :url="url"/>
        <div class="container m-5">
            <h3 class="text-center mb-5"> <i class="fab fa-paypal"></i> Pago con paypal</h3>
            <iframe :src="urlPaypal + precio+'&num='+num+'&id='+id+'&amount='+amount+'&check='+check+'&tipo='+tipo" frameborder="0" width="100%" height="500px"></iframe>
        </div>
        
    </div>
</template>

<script>
import { mapState } from 'vuex'
import { globalFunctions } from '@/hooks/globalFunctions'

import Submenu from '@/components/Submenu'
import Menu from '@/components/Menu'
export default {
    name: 'paypal',
    components:{
    Submenu,Menu
},
mixins: [ globalFunctions ],
    data(){
        return{
            
            sesion: false,
            precio: this.$route.params.price,
            num: this.$route.params.num,
            id: this.$route.params.id,
            amount: this.$route.params.amount,
            check: this.$route.params.check,
            tipo: this.$route.params.tipo,
            urlPaypal: 'http://localhost/itsapp_paypal/php/payment.php/?price=',
        }
    },
    mounted(){
        let resp = this.checkUser();
        this.sesion = resp;
        this.precio = this.$route.params.price,
        this.num = this.$route.params.num,
        this.id = this.$route.params.id,
        this.amount = this.$route.params.amount,
        this.check = this.$route.params.check,
        this.tipo = this.$route.params.tipo
        //this.urlPaypal = 
    },
    methods:{

    },
    computed:{
        ...mapState(['url'])
    },
}
</script>

<style scoped>

h3{
    color: black;
}
.fa-paypal{
    color: rgb(14, 14, 114);
}
</style>


// WEBPACK FOOTER //
// src/views/Paypal/Paypal.vue